<p-toast position="top-right" key="msj"></p-toast>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="Aceptar" rejectLabel="Cancelar"
  rejectButtonStyleClass="p-button-text">
</p-confirmDialog>

<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar" [rejectVisible]="false">
</p-confirmDialog>

<div class="container-fluid" style="border-color: #1e5a9c;">
  <div class="row">
    <div class="col-md-12 mt-2">
      <div class="card card-shadow sinborde">
        <div class="card-header sinborde" style="background: none; ">
          <div class="cardicono">
            <i class="pi pi-bolt mt-3" style="font-size: 2rem; color: #fff;"></i>
          </div>
          <header style="left: 9%; ">Bono
            <div style="color:#1e5a9c; display: inline;">de Rendimiento por Combustible </div>
          </header>
          <div id="module_main_rmop">
            <br><br>

            <div class="row mb-3 mt-1">
              <!-- <div class="col-1 "></div> -->
              <div class="col-12 xl:col-2 ml-7">
                <label for="month" style="color: #1e5a9c;" class="ml-2"><b>Mes</b></label>
                <p-dropdown (onChange)="limpiar()" [options]="months" [(ngModel)]="selectMonth" placeholder="Seleccionar" autoWidth="false"
                 optionValue="id" optionLabel="nombre" [showClear]="true"
                  [style]="{ minWidth: '100%', width: '100%' }" ></p-dropdown>
              </div>
              <div class="col-12 xl:col-2">
                <label for="month" style="color: #3c85c0;"><b>Año</b></label>
                <p-calendar (onChange)="limpiar()" [showIcon]="true" inputId="icon" [(ngModel)]="selectYear" view="year" dateFormat="yy"
                  [style]="{ minWidth: '100%', width: '95%' }" />
              </div>
              <div class="col-12 xl:col-2">
                <label style="color: #3b9be9;" class="ml-2"><b>Ciudad</b></label>
                <p-dropdown (onChange)="limpiar()" [options]="lstCiudad" [(ngModel)]="selectCity" placeholder="Seleccionar" autoWidth="false"
                optionValue="id" optionLabel="nombre" [showClear]="true"
                  [style]="{ minWidth: '100%', width: '100%' }" >
                </p-dropdown>
              </div>
              <div class="col-12 xl:col-2">
                <label for="confunit" style="color: #84c1db;" class="ml-2"><b>Configuración Unidad</b></label>
                <p-dropdown  (onChange)="limpiar()" [options]="lstConfUnidad" [(ngModel)]="selectConf" placeholder="Seleccionar" autoWidth="false"
                   optionValue="clave_configuracionUnidad" optionLabel="nombre"
                  [showClear]="false" [style]="{ minWidth: '100%', width: '100%' }" >
                </p-dropdown>
              </div>

              <div class="col-12 xl:col-2 gap-3  ml-5 d-flex align-items-end" >
                <div class="grid">
                  <div class="col-6">
                    <button pButton  label="Filtrar" id="button_search_unit" class="custom-filtrar"
                      (click)="searchUnitAction();">
                    </button>
                  </div>
                  <div class="col-6">
                    <button id="btn_down_report_gnrl" pButton pRipple  type="button" label="Exportar" [disabled]="deshabilitarbtnexportar"
                      class="custom-exc" icon="pi pi-file-export" style="text-decoration: none;"
                      (click)="exportarExcel()"></button>
                  </div>
                </div>
              </div>

            </div>

              <p-table #dt1 [value]="lstBonoRendimientoCombustible" [tableStyle]="{'min-width': '50rem'}" [paginator]="true" [rows]="25"
                [rowsPerPageOptions]="[25,50,75,100,200]" [showCurrentPageReport]="true"
                currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
                styleClass="p-datatable-sm p-datatable-striped" [globalFilterFields]="['nom_operador']"
                [resizableColumns]="false" [loading]="loading">


                <ng-template pTemplate="caption">
                  <div class="row align-items-center ">
                    <div class="col-md-5 row d-flex align-items-center">
                      <div class="col-md-6 ">
                        <button [disabled]="!lstBonoRendimientoCombustible || lstBonoRendimientoCombustible.length === 0"
                        pButton pRipple type="button" (click)="Aprobar();" label="Guardar todo" iconPos="right" icon="pi pi-arrow-up-right"
                          class="custom-button">
                        </button>
                      </div>



                    </div>


                    <div class="col-md-4 flex justify-content-end align-items-center row">

                    </div>

                    <div class="col-md-3 row">
                      <div class="flex justify-content-end">
                        <span class="p-input-icon-left p-ml-auto">
                          <i class="pi pi-search"></i>
                          <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')"
                            [style]="{ minWidth: '100%', width: '100%' }" placeholder="BUSCAR OPERADOR" />
                        </span>
                      </div>
                    </div>


                  </div>
                </ng-template>



                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="nom_operador">OPERADOR<p-sortIcon field="nom_operador"></p-sortIcon>
                    </th>
                    <th pSortableColumn="num_total_litros" class="text-center">TOTAL
                      LTS<p-sortIcon field="num_total_litros"></p-sortIcon></th>
                    <th pSortableColumn="num_total_kilometros" class="text-center">TOTAL
                      KMS<p-sortIcon field="num_total_kilometros"></p-sortIcon></th>
                    <th pSortableColumn="num_rendimiento_gen" class="text-center">
                      KM/LT<p-sortIcon field="num_rendimiento_gen"></p-sortIcon></th>
                    <th pSortableColumn="num_metrica" class="text-center">METRICA<p-sortIcon
                        field="num_metrica"></p-sortIcon></th>
                    <th pSortableColumn="num_diferencia" class="text-center">DIF<p-sortIcon
                        field="num_diferencia"></p-sortIcon></th>
                    <th pSortableColumn="num_rutas" class="text-center">RUTAS<p-sortIcon field="num_rutas"></p-sortIcon>
                    </th>
                    <th pSortableColumn="num_alcance" class="text-center">ALCANCE<p-sortIcon
                        field="num_alcance"></p-sortIcon></th>
                    <th pSortableColumn="bono" class="text-center">BONO<p-sortIcon field="bono"></p-sortIcon></th>
                    <th>ESTATUS</th>
                    <th>APROBAR</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data let-index>
                  <tr [ngClass]="{'row-baja': data.bonus_ok !=='SI'}">

                    <td><b>{{data.nom_operador}}</b></td>

                    <td class="text-center">{{data.num_total_litros}}</td>
                    <td class="text-center">{{data.num_total_kilometros}}</td>
                    <td class="text-center" style="color: rgb(90, 165, 231)"><b>{{data.num_rendimiento_gen}}</b></td>
                    <td class="text-center">{{data.num_metrica}}</td>

                    <ng-container *ngIf="data.num_diferencia < 0; else elseDifLess">
                      <td class="text-center" style="color: #e9583b"><b>{{data.num_diferencia}}</b></td>
                    </ng-container>
                    <ng-template #elseDifLess>
                      <ng-container *ngIf="data.num_diferencia > 0; else elseDifMore">
                        <td class="text-center" style="color: #3be952"><b>{{data.num_diferencia}}</b></td>
                      </ng-container>
                      <ng-template #elseDifMore>
                        <td class="text-center">{{data.num_diferencia}}</td>
                      </ng-template>
                    </ng-template>

                    <td class="text-center">{{data.num_rutas}}</td>

                    <ng-container *ngIf="data.num_diferencia < 0; else elseAlcLess">
                      <td class="text-center" style="color: #e9583b "><b>{{data.num_alcance}} %</b></td>
                    </ng-container>
                    <ng-template #elseAlcLess>
                      <ng-container *ngIf="data.num_diferencia > 0; else elseAlcMore">
                        <td class="text-center" style="color: #3be952"><b>{{data.num_alcance}} %</b></td>
                      </ng-container>
                      <ng-template #elseAlcMore>
                        <td class="text-center">{{data.num_alcance}} %</td>
                      </ng-template>
                    </ng-template>
                    <td><b>{{data.bono | currency: 'USD' }}</b></td>

                    <td >
                      <div *ngIf="data.clv_bono ==0 &&  data.bonus_ok =='SI'" style="color: #a177ee "><b>PENDIENTE</b></div>
                      <div *ngIf="data.clv_bono ===1  &&  data.bonus_ok =='SI'" style="color: #3be952"><b>APROBADO</b></div>
                      <div *ngIf="data.clv_bono ===2  &&  data.bonus_ok =='SI'" style="color: #e9583b "><b>RECHAZADO</b></div>
                      <div *ngIf=" data.bonus_ok =='NO'" style="color:  #909292"><b>DEBAJO DEL PROMEDIO</b></div>
                    </td>



                    <td >
                    <div class="d-flex gap-2 align-content-center">
                      <button *ngIf="data.bonus_ok =='SI' && data.clv_bono == 0 " pButton pRipple class="custom-buttoncargar"
                      iconPos="right"  icon="pi pi-check"  (click)="aprobarindividual(data);" pTooltip="AProbar Bono" label="Autorizar&nbsp;">
                        </button>
                        <button *ngIf="data.bonus_ok =='SI' && data.clv_bono == 0 " pButton pRipple class="custom-des"
                        iconPos="right"  icon="pi pi-delete-left"  (click)="rechazar(data);" pTooltip="Rechazar bono" label="Rechazar&nbsp;">
                          </button>
                          <button *ngIf="data.bonus_ok =='SI' && data.clv_bono !== 0 " pButton pRipple class="custom-delll"
                          iconPos="right"  icon="pi pi-trash"  (click)="eliminar(data);" pTooltip="Eliminar registro" label="Eliminar&nbsp;">
                            </button>
                          <button *ngIf="data.clv_bono == 2 " pButton pRipple class="custom-com"
                          iconPos="right"  icon="pi pi-book"  (click)="vermas(data);" pTooltip="Justificacion de Rechazo" >
                            </button>

                    </div>

                    </td>

                  </tr>

                </ng-template>
              </p-table>


          </div>






<!-- -------------pdialog para aprovar de manera masiva -->

      <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dbspagar"
      [style]="{width: '80vw','height':'800px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarModalAprobar()">
      <ng-template pTemplate="header">
        Carga Masiva de Candidatos a Bono por Rendimiento
      </ng-template>

      <ng-template pTemplate="content">

        <div class="row mt-1 d-flex justify-content-start">
          <div class="col-sm-6">
            <span style="color:  #84a0db;"><b>Selecione los choferes candidatos a bono por rendimiento
              <i class="pi pi-cog" style="size: 2rem;">
              </i></b>
            </span>
          </div>
        </div>

          <div class="mt-5 d-flex justify-content-around">
            <div class="col-md-6 row ">


              <div class="col-md-7 align-items-center">
                <div class="row">
                  <p-dropdown [options]="lstSemanas" autoWidth="false" [style]="{'width':'100%'}"
                    placeholder="Seleccione Semana*" [(ngModel)]="selectedSemana" optionLabel="nom_semana"
                    [showClear]="false">
                    <ng-template let-target pTemplate="item">
                      <div class="ui-helper-clearfix" style="position: relative; height: 25px;"
                        pTooltip="{{getTargetDescription(target)}}" tooltipPosition="top">
                        <span style="font-size: 14px; float: left; margin-top: 4px">{{target.nom_semana}}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                  <div *ngIf="selectedSemana !== null">
                    <div class="row">
                      <div [ngClass]="{'texto_sm':true}" style="color: #6cc799;" class="col-sm-6 text-left"><b>Inicio:
                          {{selectedSemana.fec_inicio | date: 'dd/MM/yyyy'}}</b></div>
                      <div [ngClass]="{'texto_sm':true}" style="color: #6cc799;" class="col-sm-6 text-right"><b>Fin:
                          {{selectedSemana.fec_fin | date: 'dd/MM/yyyy'}}</b></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-5 ">
                <button pButton pRipple type="button" (click)="guardartodo();" label="Guardar todo" icon="pi pi-save"
                  class="custom-button">
                </button>
              </div>

            </div>
            <div class="col-md-6 flex justify-content-end row">
              <div class="col-md-1"></div>
              <div class="col-md-5  ">
                <p-calendar [(ngModel)]="anio_filtro" view="year" [showIcon]="true" dateFormat="yy"
                  inputId="yearpicker" pTooltip="Año de Semanas a Consultar" tooltipPosition="top">
                </p-calendar>
              </div>

              <!-- Botón "Cargar" -->
              <div class="col-md-6">
                <button pButton pRipple label="Cargar" class="custom-delll" icon="pi pi-filter"
                  (click)="cargarListadoDeSemanasAnio_cast(anio_filtro)" pTooltip="Cargar Semanas del Año">
                </button>
              </div>
            </div>



          </div>
          <hr class="style-two ">

          <!-- Tabla con los resultados-->
          <div class="mt-5 ">
            <div class="row d-flex justify-content-center">
              <div class="col-md-1"></div>
              <div class="col-md-2 mt-2">
                <b><p-checkbox [(ngModel)]="seleccionarTodo" [binary]="true"   [ngStyle]="{ color: '#1e5a9c' }" (onChange)="toggleSeleccionarTodo()" label="Seleccionar&nbsp;Todo"
                variant="filled"></p-checkbox></b>

              </div>
              <div class="col-6 text-center">
                <h5 class="texto-pesado" style="color:#3b9be9"><b>Listado de Colaboradores</b></h5>
              </div>

              <div class="col-md-3 d-flex justify-content-end mb-2">
                <span class="p-input-icon-left p-ml-auto">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" size="35" (input)="applyFilterGlobal2($event, 'contains')"
                    placeholder="Buscar" tooltipPosition="top" class="form-control"
                   pTooltip="Buscar por nombres, apellidos o clave de colaborador" />
                </span>
              </div>
            </div>
            <p-table #dt2 [value]="lstFiltrados" [tableStyle]="{'min-width': '50rem'}" [paginator]="true" [rows]="150"
                [rowsPerPageOptions]="[50,75,100,200]" [showCurrentPageReport]="true"
                currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
                styleClass="p-datatable-sm p-datatable-striped" [globalFilterFields]="['nom_operador']"
                [resizableColumns]="false" [loading]="loadingg">



                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="nom_operador">OPERADOR<p-sortIcon field="nom_operador"></p-sortIcon>
                    </th>
                    <th class="text-center">TOTAL&nbsp;LTS</th>
                    <th class="text-center">TOTAL&nbsp;KMS</th>
                    <th class="text-center">KM/LT</th>
                    <th class="text-center">METRICA</th>
                    <th class="text-center">DIF</th>
                    <th pSortableColumn="num_rutas" class="text-center">RUTAS<p-sortIcon field="num_rutas"></p-sortIcon>
                    </th>
                    <th pSortableColumn="num_alcance" class="text-center">ALCANCE<p-sortIcon
                        field="num_alcance"></p-sortIcon></th>
                    <th pSortableColumn="bono" class="text-center">BONO<p-sortIcon field="bono"></p-sortIcon></th>
                    <!-- <th>Estatus</th> -->
                    <th>RECHAZAR</th>
                    <th>ACEPTAR</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data let-index>
                  <tr [ngClass]="{'row-baja': data.bonus_ok !=='SI'}">

                    <td><b>{{data.nom_operador}}</b></td>

                    <td class="text-center">{{data.num_total_litros}}</td>
                    <td class="text-center">{{data.num_total_kilometros}}</td>
                    <td class="text-center" style="color: rgb(90, 165, 231)"><b>{{data.num_rendimiento_gen}}</b></td>
                    <td class="text-center">{{data.num_metrica}}</td>

                    <ng-container *ngIf="data.num_diferencia < 0; else elseDifLess">
                      <td class="text-center" style="color: #e9583b"><b>{{data.num_diferencia}}</b></td>
                    </ng-container>
                    <ng-template #elseDifLess>
                      <ng-container *ngIf="data.num_diferencia > 0; else elseDifMore">
                        <td class="text-center" style="color: #3be952"><b>{{data.num_diferencia}}</b></td>
                      </ng-container>
                      <ng-template #elseDifMore>
                        <td class="text-center">{{data.num_diferencia}}</td>
                      </ng-template>
                    </ng-template>

                    <td class="text-center">{{data.num_rutas}}</td>

                    <ng-container *ngIf="data.num_diferencia < 0; else elseAlcLess">
                      <td class="text-center" style="color: #e9583b "><b>{{data.num_alcance}} %</b></td>
                    </ng-container>
                    <ng-template #elseAlcLess>
                      <ng-container *ngIf="data.num_diferencia > 0; else elseAlcMore">
                        <td class="text-center" style="color: #3be952"><b>{{data.num_alcance}} %</b></td>
                      </ng-container>
                      <ng-template #elseAlcMore>
                        <td class="text-center">{{data.num_alcance}} %</td>
                      </ng-template>
                    </ng-template>
                    <td><b>{{data.bono | currency: 'USD' }}</b></td>
                    <!-- <td class="text-center">
                      <button pButton pRipple type="button" icon="pi pi-search"
                        class="p-button-rounded p-button-info p-button-text mr-2 mb-2"
                        (click)="chargeOpServInfo(data.jsn_serv)"></button>
                    </td> -->
                    <td class="text-center">
                      <p-checkbox [(ngModel)]="data.clv_rechazar" [binary]="true" (onChange)="rechazarmasivo(data)"
                        variant="filled"></p-checkbox>
                    </td>
                    <td class="text-center">
                      <p-checkbox [(ngModel)]="data.clv_activo" [binary]="true" (onChange)="aprobarmarivoindividual(data)"
                        variant="filled"></p-checkbox>
                    </td>



                  </tr>

                </ng-template>
              </p-table>


          </div>

      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarModalAprobar();"></button>
      </ng-template>
    </p-dialog>





 <!----------------------------- pdialog para rechazar bono -->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dsprechazar"
    [style]="{width: '50vw','height':'630px'}" [transitionOptions]="'0ms'"
    (onHide)="cancelarrechazar()">
    <ng-template pTemplate="header">
     Rechazar Bono de Rendimiento por Combustible
    </ng-template>
    <ng-template pTemplate="content">
      <div class="card-content">
        <!-- <form class="form_cliente" [formGroup]="agregarTextoForm" (ngSubmit)="rechazarguardar()"> -->
          <div class="ml-1">
            <div class="row mt-1 d-flex justify-content-start">
              <div class="col-sm-6">
                <span class="title-light">Proporcione la informacion solcitada
                  <i class="pi pi-cog" style="size: 2rem;"></i>
                </span>
              </div>
            </div>
            <div class="row" ><b><label style="color: #909292;">Colaborador:&nbsp;</label><label style="color: #59a7e7;" >{{this.colaborador}}</label></b></div>

            <!-- <div class="row ml-2" ><b><label style="color: #909292;">Importe Bono por Rendimiento:&nbsp;</label><label style="color: #59a7e7;" >{{this.importe  | currency: 'USD'}}</label></b></div> -->

            <div class="mt-3 d-flex justify-content-around">
              <div class="col-md-6 row ">


                <div class="col-md-10 align-items-center">
                  <div class="row">
                    <p-dropdown [options]="lstSemanas" autoWidth="false" [style]="{'width':'100%'}"
                      placeholder="Seleccione Semana*" [(ngModel)]="selectedSemana" optionLabel="nom_semana"
                      [showClear]="false">
                      <ng-template let-target pTemplate="item">
                        <div class="ui-helper-clearfix" style="position: relative; height: 25px;"
                          pTooltip="{{getTargetDescription(target)}}" tooltipPosition="top">
                          <span style="font-size: 14px; float: left; margin-top: 4px">{{target.nom_semana}}</span>
                        </div>
                      </ng-template>
                    </p-dropdown>
                    <div *ngIf="selectedSemana !== null">
                      <div class="row">
                        <div [ngClass]="{'texto_sm':true}" style="color: #6cc799;" class="col-sm-6 text-left"><b>Inicio:
                            {{selectedSemana.fec_inicio | date: 'dd/MM/yyyy'}}</b></div>
                        <div [ngClass]="{'texto_sm':true}" style="color: #6cc799;" class="col-sm-6 text-right"><b>Fin:
                            {{selectedSemana.fec_fin | date: 'dd/MM/yyyy'}}</b></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-2 ">
                  <!-- <button pButton pRipple type="button" (click)="guardartodo();" label="Guardar todo" icon="pi pi-save"
                    class="custom-button">
                  </button> -->
                </div>

              </div>
              <div class="col-md-6 flex justify-content-end row">
                <div class="col-md-1"></div>
                <div class="col-md-5  ">
                  <p-calendar [(ngModel)]="anio_filtro" view="year" [showIcon]="true" dateFormat="yy"
                    inputId="yearpicker" pTooltip="Año de Semanas a Consultar" tooltipPosition="top">
                  </p-calendar>
                </div>

                <!-- Botón "Cargar" -->
                <div class="col-md-6">
                  <button pButton pRipple label="Cargar" class="custom-delll" icon="pi pi-filter"
                    (click)="cargarListadoDeSemanasAnio_cast(anio_filtro)" pTooltip="Cargar Semanas del Año">
                  </button>
                </div>
              </div>



            </div>
            <hr class="style-two">
            <div class="row mt-2">
              <p><span style="font-weight: bold; ">¿Cuál es el motivo para no autorizar el bono?</span></p>
            </div>

            <div class=" col-md-12 mt-2 justify-content-center text-center align-items-center">
              <textarea [(ngModel)]="respuesta" class="form-control" rows="5"
                placeholder="Escribe tu respuesta aquí" [style]="{'width':'80%', 'margin-top': '20px'}"
                pTooltip="Escribe tu respuesta" tooltipPosition="top"></textarea>
            </div>
            <!-- Información de la última modificación -->
            <div class="row d-flex ">
              <div class="col-md-5  mt-6 justify-content-start">
                <!-- <p><span style="font-weight: bold; ">Última Modificación:</span></p>
                <p style="margin-top: 0px;  color: rgb(181, 17, 50);">
                  <b>{{ bonoPermaneciaForm.get('nom_usuario_mod')?.value }}</b>
                </p> -->
              </div>
              <div class="col-md-3 mt-7 justify-content-center">
                <button class="custom-button" type="submit" pTooltip="Almacenar información"
                  tooltipPosition="right" (click)="rechazarguardarindividual()">
                  <span class="text-white">Guardar&nbsp;</span>
                  <i class="pi pi-save text-white"></i>
                </button>
              </div>
            </div>
          </div>
        <!-- </form> -->
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelarrechazar()"></button>
    </ng-template>
  </p-dialog>



  <!----------------------------- pdialog para rechazar bono -->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dsprechazarmasivo"
  [style]="{width: '50vw','height':'550px'}" [transitionOptions]="'0ms'"
  (onHide)="cancelarrechazarmasivoindi()">
  <ng-template pTemplate="header">
   Rechazar Bono de Rendimiento por Combustible
  </ng-template>
  <ng-template pTemplate="content">
    <div class="card-content">
      <!-- <form class="form_cliente" [formGroup]="agregarTextoForm" (ngSubmit)="rechazarguardar()"> -->
        <div class="ml-1">
          <div class="row mt-1 d-flex justify-content-start">
            <div class="col-sm-6">
              <span class="title-light">Proporcione la informacion solcitada
                <i class="pi pi-cog" style="size: 2rem;"></i>
              </span>
            </div>
          </div>
          <div class="row" ><b><label style="color: #909292;">Colaborador:&nbsp;</label><label style="color: #59a7e7;" >{{this.colaborador}}</label></b></div>

          <!-- <div class="row ml-2" ><b><label style="color: #909292;">Importe Bono por Rendimiento:&nbsp;</label><label style="color: #59a7e7;" >{{this.importe  | currency: 'USD'}}</label></b></div> -->

          <div class="row mt-2">
            <p><span style="font-weight: bold; ">¿Cuál es el motivo para no autorizar el bono?</span></p>
          </div>

          <div class=" col-md-12 mt-3 justify-content-center text-center align-items-center">
            <textarea [(ngModel)]="respuesta" class="form-control" rows="5"
              placeholder="Escribe tu respuesta aquí" [style]="{'width':'80%', 'margin-top': '20px'}"
              pTooltip="Escribe tu respuesta" tooltipPosition="top"></textarea>
          </div>
          <!-- Información de la última modificación -->
          <div class="row d-flex ">
            <div class="col-md-5  mt-6 justify-content-start">
              <!-- <p><span style="font-weight: bold; ">Última Modificación:</span></p>
              <p style="margin-top: 0px;  color: rgb(181, 17, 50);">
                <b>{{ bonoPermaneciaForm.get('nom_usuario_mod')?.value }}</b>
              </p> -->
            </div>
            <div class="col-md-3 mt-7 justify-content-center">
              <button class="custom-button" type="submit" pTooltip="Almacenar información"
                tooltipPosition="right" (click)="rechazarguardarlista()">
                <span class="text-white">Guardar&nbsp;</span>
                <i class="pi pi-save text-white"></i>
              </button>
            </div>
          </div>
        </div>
      <!-- </form> -->
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="cancelarrechazarmasivoindi()"></button>
  </ng-template>
</p-dialog>


<!-- ---------------pdialog para aprobar de manera individual -->

<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspaprobarindividual"
[style]="{width: '50vw','height':'550px'}" [transitionOptions]="'0ms'"
(onHide)="cancelaraprobarindividual()">
<ng-template pTemplate="header">
 Aprobar Bono de Rendimiento por Combustible
</ng-template>
<ng-template pTemplate="content">
  <div class="card-content">
    <!-- <form class="form_cliente" [formGroup]="agregarTextoForm" (ngSubmit)="rechazarguardar()"> -->
      <div class="ml-1">
        <div class="row mt-1 d-flex justify-content-start">
          <div class="col-sm-10">
            <span class="title-light">Seleccione la semana en la que se pretende pagar el beneficio.
              <i class="pi pi-cog" style="size: 2rem;"></i>
            </span>
          </div>
        </div>
        <!-- <div class="row ml-2" style="color: #909292;"><b>Colaborador:{{this.colaborador}}</b></div> -->
        <div class="row ml-2" ><b><label style="color: #909292;">Colaborador:&nbsp;</label><label style="color: #59a7e7;" >{{this.colaborador}}</label></b></div>

        <div class="row ml-2" ><b><label style="color: #909292;">Importe Bono por Rendimiento:&nbsp;</label><label style="color: #59a7e7;" >{{this.importe  | currency: 'USD'}}</label></b></div>
        <!-- <hr class="style-two"> -->
        <div class="mt-4 d-flex justify-content-around">
          <div class="col-md-6 row d-flex align-items-center">
            <div class="col-md-3 ">
              <!-- <button pButton pRipple type="button" (click)="Aprobar();" label="Guardar todo" icon="pi pi-save"
                class="custom-button">
              </button> -->
            </div>

            <div class="col-md-9 mt-1">
              <div class="row">
                <p-dropdown [options]="lstSemanas" autoWidth="false" [style]="{'width':'100%'}"
                  placeholder="Seleccione Semana*" [(ngModel)]="selectedSemana" optionLabel="nom_semana"
                  [showClear]="false">
                  <ng-template let-target pTemplate="item">
                    <div class="ui-helper-clearfix" style="position: relative; height: 25px;"
                      pTooltip="{{getTargetDescription(target)}}" tooltipPosition="top">
                      <span style="font-size: 14px; float: left; margin-top: 4px">{{target.nom_semana}}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <div *ngIf="selectedSemana !== null">
                  <div class="row">
                    <div  [ngClass]="{'texto_sm':true}" style="color: #6cc799;" class="col-sm-6 text-left"><b>Inicio:
                        {{selectedSemana.fec_inicio | date: 'dd/MM/yyyy'}}</b></div>
                    <div [ngClass]="{'texto_sm':true}"style="color: #6cc799;" class="col-sm-6 text-right"><b>Fin:
                        {{selectedSemana.fec_fin | date: 'dd/MM/yyyy'}}</b></div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-6 flex justify-content-end align-items-center row">
            <div class="col-md-1"></div>
            <div class="col-md-5  ">
              <p-calendar [(ngModel)]="anio_filtro" view="year" [showIcon]="true" dateFormat="yy"
                inputId="yearpicker" pTooltip="Año de Semanas a Consultar" tooltipPosition="top">
              </p-calendar>
            </div>

            <!-- Botón "Cargar" -->
            <div class="col-md-6">
              <button pButton pRipple label="Cargar" class="custom-delll" icon="pi pi-filter"
                (click)="cargarListadoDeSemanasAnio_cast(anio_filtro)" pTooltip="Cargar Semanas del Año">
              </button>
            </div>
          </div>



        </div>
        <hr class="style-two">
        <!-- Información de la última modificación -->
        <div class="row d-flex ">
          <div class="col-md-5  mt-6 justify-content-start">

          </div>
          <div class="col-md-3 mt-7 justify-content-center">
            <button class="custom-button" type="submit" pTooltip="Almacenar información"
              tooltipPosition="right" (click)="guardarindividual()">
              <span class="text-white">Guardar </span>
              <i class="pi pi-save text-white"></i>
            </button>
          </div>
        </div>
      </div>
    <!-- </form> -->
  </div>
</ng-template>
<ng-template pTemplate="footer">
  <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
    (click)="cancelaraprobarindividual()"></button>
</ng-template>
</p-dialog>


<!-- ---------ver mas---------- -->
<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspVerMas" [style]="{width: '35vw','height':'430px'}"
(onHide)="verMenos()" [transitionOptions]="'0ms'" styleClass="card-shadow">
<ng-template pTemplate="header">
   Motivo del Rechazo del Bono
</ng-template>
<ng-template pTemplate="content">
  <form class="form_cliente" [formGroup]="reactive" (ngSubmit)="verMenos()">
    <div class="row  pb-2">

      <!-- tipo de incapacuidad -->

      <div class="row d-flex mt-3">
        <label style=" font-weight: bold;" class="title-light">Colaborador: {{this.chofer}}</label>
        <textarea rows="5" cols="50" pInputTextarea formControlName="comentario"></textarea>
      </div>
    </div>
    <div class="mt-2 d-flex justify-content-center">
      <button type="submit" class="custom-filtrar">ACEPTAR</button>
    </div>
  </form>
</ng-template>
<ng-template pTemplate="footer">
  <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
    (click)="verMenos();"></button>
</ng-template>
</p-dialog>


   </div>

